import produce from 'immer'
import { baseReportUrl } from 'environments'
import { createActions, normalizeDateRange } from 'helpers/actions'
import entityNames from 'options/entityNames'

const entityName = entityNames.itemHistoryReport

export default createActions(entityName, {
  basePath: 'report/orderReports',
  baseUrl: baseReportUrl,
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.locationVendingTypes = ['NonVending', 'Vending']

      normalizeDateRange(draft)
    }),
})
